import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CallbackWrapperService, PinRejectedSubject } from 'projects/login/src/app/services/callback-wrapper.service';
import { catchError, Observable } from 'rxjs';
import { environment as env } from '../../../environments/environment';
import { GenerateQRResponse } from './models/generate-qr-response';
import { TwoFaSetupRequest } from './models/two-fa-setup-request';
import { VerifyRequest } from './models/verify-request';
import { VerifyResponse } from './models/verify-response';

@Injectable({
  providedIn: 'root',
})
export class TwoFaService {
  private readonly _httpClient = inject(HttpClient);
  private readonly _cbs = inject(CallbackWrapperService);

  basePath: string = env.authUrl + '/v2/accounts/2fa';
  authUrl: string = env.authUrl + '/v2/authentication/mfa/challenge';

  private qrData?: Observable<GenerateQRResponse>;

  verify(verifyRequest: VerifyRequest) {
    return this._httpClient.post<VerifyResponse>(this.authUrl + '/verify', verifyRequest).pipe(
      catchError((error) => {
        this._cbs.getSubject<void>(PinRejectedSubject).next();
        throw error;
      }),
    );
  }

  twoFaSetup(twoFaSetupRequest: TwoFaSetupRequest) {
    return this._httpClient.patch<void>(this.basePath, twoFaSetupRequest);
  }

  // Method only sms for now, more might be supported in the future.
  trigger(method: 'sms' = 'sms') {
    return this._httpClient.post(`${this.authUrl}/trigger`, {
      method,
    });
  }

  generateQr(bearer: string) {
    if (!this.qrData) {
      this.qrData = this._httpClient.get<GenerateQRResponse>(`${this.basePath}/generate-qr`, {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
      });
    }
    return this.qrData;
  }

  resetQrData() {
    this.qrData = undefined;
  }

  getLinkToken(bearer: string, email: string) {
    return this._httpClient.get<{
      token: string;
      email: string;
    }>(`/v2/accounts/2fa/hubspot-link?email=${email}`, {
      headers: {
        Authorization: `Bearer ${bearer}`,
      },
    });
  }
}
